// extracted by mini-css-extract-plugin
module.exports = {"faq":"styles_faq__1SQFQ","cup":"styles_cup__1Ru1R","content":"styles_content__1FYtq","notMobile":"styles_notMobile__kmb-b","noUnderline":"styles_noUnderline__RoMES"};